import { HttpContextToken } from "@angular/common/http";

/**
 * Token used to indicate whether the authentication interceptor should be bypassed for a specific request.
 * Defaults to `false`.
 */
export const BYPASS_AUTH_INTERCEPTOR = new HttpContextToken<boolean> (() => false);
